import jQuery from "jquery";
import CartJS from "./cart";

/* eslint-disable no-use-before-define */
/* eslint-disable eqeqeq */
/* eslint-disable no-undef */
const $ = jQuery;

$(document).ready(() => {
    // Initialise Cart.js once the page has loaded
    CartJS.init(window.theme.cart);

    // eslint-disable-next-line func-names
    const openMiniCart = () => {
        // if ($('.header-icons-cart-container').hasClass('active') == false) {
        //   $('.header-icons-cart-container').addClass('active');
        // }
        if ($(".cart__frenzypopup").hasClass("active") == false) {
            $(".cart__frenzypopup").addClass("active");
        }
        $(".cart-modal").show();
    };

    // Update cart count when product is added
    document.addEventListener("cart.requestComplete", (event) => {
        const totalCartCount = parseInt(
            $(".header-icons-cart-count").text(),
            10,
        );
        $(".header-icons-cart-count").html(event.detail.cart.item_count);
        loadCartContents();

        if (
            event.detail.cart.item_count > totalCartCount &&
            $(".template-cart").length == 0
        ) {
            openMiniCart();
        }

        // Update the cart page
        if ($(".template-cart").length > 0) {
            $("#cartTemplateContainer").load(
                "/cart?view=update .cart-template-main",
            );
        }
    });

    $(".header-icons-cart-button").click(() => {
        if ($(".template-cart").length == 0) {
            openMiniCart();
        }
    });

    $(".cart-modal").on(
        "click",
        () => {
            // $('.header-icons-cart-container').toggleClass('active');
            $(".cart__frenzypopup").toggleClass("active");
            $(".cart-modal").hide();
        },
        false,
    );

    function loadCartContents() {
        fetch("/cart?view=header")
            .then((response) => response.text())
            .then((text) => {
                const element = document.querySelector(
                    ".header-icons-cart-container",
                );
                if (element) {
                    element.innerHTML = text;
                    // eslint-disable-next-line no-shadow
                    element
                        .querySelectorAll("button[close-cart]")
                        .forEach((element) =>
                            element.addEventListener("click", () => {
                                // $('.header-icons-cart-container').toggleClass('active');
                                $(".cart__frenzypopup").toggleClass("active");
                                $(".cart-modal").hide();
                            }),
                        );
                }
            })
            // eslint-disable-next-line no-console
            .catch((err) => console.warn("Something went wrong.", err));
    }

    loadCartContents();
});
